import {trackEvent} from '@hconnect/common/logging/Analytics'
import {useRequiredUser} from '@hconnect/login'
import {useUpmPlantContext} from '@hconnect/upm'
import {useCallback} from 'react'

const productionPlanningEvents = [
  'onSubmitPlanClick',
  'onEditScheduleItem',
  'onDeleteScheduleItem',
  'onAddScheduleItem',
  'onCommentAddToScheduleItem',
  'onCommentEditToScheduleItem',
  'onCommentDeleteToScheduleItem',
  'onCommentAddToAsset',
  'onCommentDeleteToAsset',
  'onCommentEditToAsset',
  'onExportProductionPlan'
] as const

type PlannerEventName = (typeof productionPlanningEvents)[number]

type PlannerEvent = {
  name: PlannerEventName
  [key: string]: unknown
}

export const useTrackPlannerEvent = () => {
  const {plantId} = useUpmPlantContext()
  const {country, name: plantName} = useUpmPlantContext()
  const {user_id: userId} = useRequiredUser()

  return useCallback(
    ({name, ...otherEventProps}: PlannerEvent) => {
      return trackEvent(name, {
        product: 'planner',
        plantId,
        plantName,
        country,
        userId,
        feature: 'ProductionPlanning',
        ...otherEventProps
      })
    },
    [country, plantId, plantName, userId]
  )
}
